import { render, staticRenderFns } from "./PackEdit.vue?vue&type=template&id=032ac064&scoped=true&"
import script from "./PackEdit.vue?vue&type=script&lang=js&"
export * from "./PackEdit.vue?vue&type=script&lang=js&"
import style0 from "./PackEdit.vue?vue&type=style&index=0&id=032ac064&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032ac064",
  null
  
)

export default component.exports